import React from 'react';
import { Card, CardContent, Typography, Chip, Box } from '@mui/material';
import { Calendar, Phone } from 'lucide-react';

const EventCard = ({ title, date, content, selectedOption }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <Card sx={{
      borderRadius: 3,
      transition: 'transform 0.2s, box-shadow 0.2s',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: (theme) => theme.shadows[8]
      }
    }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, flex: 1, mr: 2 }}>
            {title}
          </Typography>
          <Chip
            label={selectedOption}
            size="small"
            color="primary"
            sx={{ borderRadius: '16px' }}
          />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
            <Calendar size={16} style={{ marginRight: 8 }} />
            <Typography variant="body2">
              {formatDate(date)}
            </Typography>
          </Box>
          {content && (
            <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
              <Typography variant="body2">{content}</Typography>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default EventCard;